var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-footer"},[_vm._v(" Application développée par "),_c('a',{attrs:{"href":"https://www.stephanealetru.fr","target":"_blank"}},[_vm._v(" Stéphane Alétru")]),_vm._v(" © "+_vm._s(_vm.date)+" Tous droits reservés ")])}
var staticRenderFns = []

export { render, staticRenderFns }